export enum StatusKanban {
  aguardando = 'Aguardando',
  emAndamento = 'Em andamento',
  realizado = 'Realizado',
  naoRealizado = 'Não Realizado',
}
